import React from 'react';
import {
  Container,
  Typography,
  Paper,
} from '@mui/material';

const PrivacyPolicyPage = () => {
  return (
    <Container maxWidth="lg" sx={{ py: 8 }}>
      <Paper elevation={0} sx={{ p: 4 }}>
        <Typography variant="h3" component="h1" gutterBottom>
          Privacy Policy
        </Typography>

        <Typography variant="h5" gutterBottom sx={{ mt: 4 }}>
          1. Information We Collect
        </Typography>
        <Typography variant="body1" paragraph>
          At cleverCV, we forget the information as soon as you download your new resume! We ensure no information is persisted by any LLM we use, nor do we store any of your information, not even your email address. Our business isn't to sell your information to other companies, nor is it to spam you. This website was built to assist people to create cv's, and to avoid the struggle of navigating how to create the perfect cv.
        </Typography>

        <Typography variant="h5" gutterBottom sx={{ mt: 4 }}>
          2. Contact Us
        </Typography>
        <Typography variant="body1" paragraph>
          If you have any questions about this Privacy Policy, please contact us at sherry@friendlymeerkat.co.za.
        </Typography>
      </Paper>
    </Container>
  );
};

export default PrivacyPolicyPage; 